import React, { Component } from 'react';
import { node, func, string } from 'prop-types';
import classnames from 'classnames';

import styles from './Form.css';

export default class Form extends Component {
  static propTypes = {
    onSubmit: func,
    children: node.isRequired,
    id: string,
    className: string,
  }

  handleFormSubmit = () => {
    this.props.onSubmit && this.props.onSubmit();
  }

  render() {
    const { children, id, className } = this.props;

    const formClass = classnames(
      styles.form,
      'flex flex-column',
      className
      );

    return (
      <form onSubmit={this.handleFormSubmit} id={id} className={formClass}>
        { children }
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/components/Form/Form.js